var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.356,
    height: 60.712,
    viewBox: "0 0 46.356 60.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20496",
    "data-name": "Path 20496",
    d: "M113.6,13.28a12.851,12.851,0,0,1-3.89,9.39,12.851,12.851,0,0,1-9.39,3.89h-.006a12.853,12.853,0,0,1-9.384-3.89,12.85,12.85,0,0,1-3.89-9.39,12.848,12.848,0,0,1,3.89-9.389A12.847,12.847,0,0,1,100.309,0h.006a12.855,12.855,0,0,1,9.39,3.89A12.85,12.85,0,0,1,113.6,13.28Zm0,0",
    transform: "translate(-77.54)",
    fill: "#ffbb85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20497",
    "data-name": "Path 20497",
    d: "M46.054,266.342a9.154,9.154,0,0,1-2.72,6.927c-1.783,1.7-4.293,5.957-7.16,5.957L23.006,281.4l-5.572-.178s-2.425-.472-4.447-.97a13.727,13.727,0,0,1-3.638-1.023c-2.951-1.106-6.384-1.7-8.166-3.4C-.622,274.107.05,269.22.05,266.342c0-1.107.037-2.2.11-3.256A32.6,32.6,0,0,1,.607,259.6a27.5,27.5,0,0,1,.856-3.5,17.364,17.364,0,0,1,1.44-3.268A12.367,12.367,0,0,1,5.074,250a9.576,9.576,0,0,1,3.12-1.96,10.787,10.787,0,0,1,3.982-.72,4.035,4.035,0,0,1,2.157.914c.657.429,1.414.917,2.25,1.451a12.858,12.858,0,0,0,2.908,1.282,11.607,11.607,0,0,0,3.206.569q.176.006.352.006a11.569,11.569,0,0,0,3.559-.575,12.858,12.858,0,0,0,2.909-1.282c.845-.54,1.6-1.027,2.249-1.45a4.031,4.031,0,0,1,2.159-.915,10.792,10.792,0,0,1,3.982.72A9.584,9.584,0,0,1,41.027,250a12.323,12.323,0,0,1,2.172,2.83,17.313,17.313,0,0,1,1.44,3.266,27.489,27.489,0,0,1,.857,3.5,32.907,32.907,0,0,1,.446,3.484C46.016,264.135,46.052,265.23,46.054,266.342Zm0,0",
    transform: "translate(0.072 -220.685)",
    fill: "#d5e4fe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20498",
    "data-name": "Path 20498",
    d: "M210.3,26.56h-.006V0h.006a12.854,12.854,0,0,1,9.39,3.89,12.85,12.85,0,0,1,3.891,9.389,12.851,12.851,0,0,1-3.891,9.39A12.851,12.851,0,0,1,210.3,26.56Zm0,0",
    transform: "translate(-187.523)",
    fill: "#f5a86c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20499",
    "data-name": "Path 20499",
    d: "M233.649,266.342c0,2.879.911,7.715-.893,9.432a13.739,13.739,0,0,1-8.222,3.469l-6.672,1.486-7.569.586V251.536q.176.006.352.006a11.569,11.569,0,0,0,3.559-.575,12.857,12.857,0,0,0,2.909-1.282c.845-.54,1.6-1.027,2.249-1.45a4.031,4.031,0,0,1,2.158-.915,10.793,10.793,0,0,1,3.982.72,9.584,9.584,0,0,1,3.119,1.96,12.321,12.321,0,0,1,2.172,2.83,17.319,17.319,0,0,1,1.44,3.266,27.466,27.466,0,0,1,.857,3.5,32.865,32.865,0,0,1,.446,3.484C233.611,264.135,233.648,265.23,233.649,266.342Zm0,0",
    transform: "translate(-187.523 -220.685)",
    fill: "#b8d1fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.24573994744cc16c1fb0b31be1d36145.svg";
export { ForwardRef as ReactComponent };